import React from "react";

import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";

import KeyboardArrowDownIcon from "assets/icons/KeyboardArrowIcon";

import topic_1 from "../../assets/consultings/topics/topic_1.png";
import topic_2 from "../../assets/consultings/topics/topic_2.png";
import topic_3 from "../../assets/consultings/topics/topic_3.png";
import topic_4 from "../../assets/consultings/topics/topic_4.png";
import topic_5 from "../../assets/consultings/topics/topic_5.png";
import topic_6 from "../../assets/consultings/topics/topic_6.png";
import topic_7 from "../../assets/consultings/topics/topic_7.png";
import topic_8 from "../../assets/consultings/topics/topic_8.png";
import topic_9 from "../../assets/consultings/topics/topic_9.png";
import topic_10 from "../../assets/consultings/topics/topic_10.png";
import topic_11 from "../../assets/consultings/topics/topic_11.png";
import topic_12 from "../../assets/consultings/topics/topic_12.png";

const Topic = () => {
  const topics = [
    { image: topic_1 },
    { image: topic_2 },
    { image: topic_3 },
    { image: topic_4 },
    { image: topic_5 },
    { image: topic_6 },
    { image: topic_7 },
    { image: topic_8 },
    { image: topic_9 },
    { image: topic_10 },
    { image: topic_11 },
    { image: topic_12 },
  ];

  const AccordionItem = ({ header, order, ...rest }) => {
    return (
      <Item
        {...rest}
        header={({ state: { isEnter } }) => (
          <div className="flex flex-row items-center gap-4">
            <div className="flex gap-3 pt-3 pb-4 space-y-6 md:pt-6 md:pb-8">
              <p className="text-xl font-bold text-start sm:text-2xl app-animation-translate-start">
                {header}
              </p>
            </div>
            <div>
              <KeyboardArrowDownIcon
                className={`h-4 md:h-6 xl:h-8 w-2 md:w-4 xl:w-6 ml-auto fill-black transition-transform duration-200 ease-out mt-[-0.25em] ${
                  isEnter && "rotate-180"
                }`}
              />
            </div>
          </div>
        )}
        className={""}
        buttonProps={{
          className: ({ isEnter }) => `w-full text-left`,
        }}
        contentProps={{
          className: "transition-height duration-200 ease-out",
        }}
        panelProps={{ className: "" }}
        initialEntered={false}
      />
    );
  };

  return (
    <div className="space-y-8 app-main-container">
      <Accordion
        className="flex items-center app-animation-scale-start"
        transition
        transitionTimeout={200}
      >
        <AccordionItem header={"Topics"}>
          <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
            {topics.map((item, i) => (
              <div
                key={i}
                className="flex flex-col gap-2 cursor-pointer app-animation-scale-start"
              >
                <img
                  src={item.image}
                  alt={`topic-${i + 1}`}
                  className="object-cover w-full border rounded-lg aspect-square"
                />
              </div>
            ))}
          </div>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Topic;
